MeService.$inject = ['$http']

export default function MeService($http) {
  return {
    getOrders: function(profileId) {
      return $http.get('/api-prema2/orders?filter[where][profileId]=' + profileId + '&filter[where][createdById]=' + localStorage.getItem('userId') + '&filter[order]=createdAt%20DESC')
    }
  }
}